// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/main.scss
// module id = 2
// module chunks = 0